window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

window.Ajax = require('./util/ajax').default;
window.FormModal = require('./util/form-modal').default;
window.FileFormModal = require('./util/file-form-modal').default;
window.DeleteFormModal = require('./util/delete-form-modal').default;
window.Combo = require('./util/combo').default;
window.Fecha = require('./util/fecha').default;
window.ClientAddLicenciaCodeForm = require('./client/client-add-licencia-code-form').default;

window.AdminEmpresaForm = require('./admin/empresa/empresa-form').default;
window.AdminEmpresaLista = require('./admin/empresa/empresa-lista').default;
window.AdminPaqueteForm = require('./admin/paquete/paquete-form').default;
window.AdminPaqueteLista = require('./admin/paquete/paquete-lista').default;
window.AdminPaqueteGestion = require('./admin/paquete/paquete-gestion').default;
window.Licencia = require('./admin/licencia/licencia').default;
window.AdminLicenciaLista = require('./admin/licencia/licencia-lista').default;
window.AdminLicenciaActivadaForm = require('./admin/licencia/licencia-activada-form').default;
window.AdminLoteLicenciaLista = require('./admin/lote-licencia/lote-licencia-lista').default;
window.AdminLoteLicenciaForm = require('./admin/lote-licencia/lote-licencia-form').default;
window.AdminDocenteLista = require('./admin/docente/docente-lista').default;
window.AdminDocenteForm = require('./admin/docente/docente-form').default;
window.AdminDocenteImportarForm = require('./admin/docente/docente-importar-form').default;
window.AdminAulaLista = require('./admin/aula/aula-lista').default;
window.AdminAulaForm = require('./admin/aula/aula-form').default;
window.AdminAulaImportarForm = require('./admin/aula/aula-importar-form').default;

window.AdminNotificacionLista = require('./admin/notificacion/notificacion-lista').default;
window.AdminNotificacionForm = require('./admin/notificacion/notificacion-form').default;
window.AdminNotificacionLicenciaLista = require('./admin/notificacion/notificacion-licencia-lista').default;
window.NotificacionService = require('./admin/notificacion/notificacion-service').default;
window.AdminLicenciaNoNotificadasLista = require('./admin/licencia/no-notificadas-lista').default;
